import React, { useEffect, useState } from 'react'
import { CCol, CRow, CSpinner } from '@coreui/react'
import { api } from '../api/client'
import WwGrid, { WwColumn } from '../components/ww/WwGrid'

// Sesiones activas (global) — ruta /superadmin/sesiones.
// UsuarioOnline == true en todas las empresas. Inicio de sesión / última
// actividad NO existen como columnas en el esquema GX: no se inventan.
const SuperAdminSesionesPage: React.FC = () => {
  const [sesiones, setSesiones] = useState<any[]>([])
  const [cargando, setCargando] = useState(true)

  useEffect(() => {
    api.get<any[]>('/superadmin/sesiones')
      .then(setSesiones)
      .catch(() => undefined)
      .finally(() => setCargando(false))
  }, [])

  const columnas: WwColumn[] = [
    { key: 'usuarioCodigo', title: 'Usuario' },
    { key: 'usuarioNombre', title: 'Nombre' },
    { key: 'empresaCodigo', title: 'Empresa' },
    { key: 'rolNombre', title: 'Rol' },
    { key: 'usuarioEstado', title: 'Estado' },
  ]

  return (
    <>
      <CRow className="mb-4">
        <CCol>
          <h4 className="mb-0 fw-bold">Sesiones</h4>
          <small className="text-body-secondary">
            Usuarios conectados ahora (UsuarioOnline = true), todas las empresas.
          </small>
        </CCol>
      </CRow>
      {cargando ? (
        <div className="text-center py-4"><CSpinner color="primary" /></div>
      ) : (
        <WwGrid title="Sesiones" columns={columnas} rows={sesiones} onTotalChange={() => undefined} />
      )}
    </>
  )
}

export default SuperAdminSesionesPage
